module.exports = __webpack_public_path__ + "img/card-emtenan-2.9e080fee.jpg";